import { createFileRoute, redirect } from '@tanstack/react-router';

import { BILLING_PRODUCT_PATH } from '@/modules/billing-product/route';

// Caminho da 1ª aba no legado (`router.tsx:1819`): link salvo continua valendo e cai no hub.
export const Route = createFileRoute('/_app/cadastro/gestao/produtos-cobranca/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() é o contrato do TanStack Router.
    throw redirect({ to: BILLING_PRODUCT_PATH, replace: true });
  },
});
